import { Injectable } from '@angular/core';

import { NgRedux } from '@angular-redux/store';

import { RidangoReduxAction } from '@ridango/core';

import { Observable } from 'rxjs';

import { BankcardTicket } from '../model/bankcard-ticket.model';
import { BankcardTransaction } from '../model/bankcard-transaction.model';
import { BankcardTicketsActions } from './bankcard-tickets.actions';
import { BankcardTicketsPartialStoreState } from './bankcard-tickets.reducer';
import * as BankcardTicketsSelectors from './bankcard-tickets.selectors';

@Injectable()
export class BankcardTicketsFacade {
    transaction$: Observable<BankcardTransaction> = this.store.select(BankcardTicketsSelectors.getTransaction);
    error$: Observable<any> = this.store.select(BankcardTicketsSelectors.getError);
    ticketsError$: Observable<any> = this.store.select(BankcardTicketsSelectors.getTicketsError);
    tickets$: Observable<BankcardTicket[]> = this.store.select(BankcardTicketsSelectors.getTickets);
    ticketsLoading$: Observable<boolean> = this.store.select(BankcardTicketsSelectors.getTicketsLoading);
    hslTickets$: Observable<BankcardTicket[]> = this.store.select(BankcardTicketsSelectors.getHslTickets);
    hslTicketsLoading$: Observable<boolean> = this.store.select(BankcardTicketsSelectors.getHslTicketsLoading);
    loading$: Observable<boolean> = this.store.select(BankcardTicketsSelectors.getLoading);
    feedbackSuccess$: Observable<boolean> = this.store.select(BankcardTicketsSelectors.getFeedbackSuccess);

    constructor(private store: NgRedux<BankcardTicketsPartialStoreState>, private actions: BankcardTicketsActions) {}

    dispatch(action: RidangoReduxAction) {
        this.store.dispatch(action);
    }

    fetchTransaction(regionId: number) {
        this.dispatch(this.actions.fetchTransaction(regionId));
    }

    fetchTickets(transactionId: number, lang: string = '') {
        this.dispatch(this.actions.fetchTickets(transactionId, lang));
    }

    fetchHslTickets(transactionId: number) {
        this.dispatch(this.actions.fetchHslTickets(transactionId));
    }

    cleanState() {
        this.dispatch(this.actions.cleanState());
    }

    sendFeedback(formData) {
        this.dispatch(this.actions.sendFeedback(formData));
    }
}
